import React, { Component } from 'react';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import isMobile from 'ismobilejs';

import { ANIMATION_TIMINGS } from '../constants/styles';
import {
    hideWebview,
    updateWebviewTitle,
    resetWebview,
    showWebviewContent,
    hideWebviewContent,
} from '../actions/webview';

import LinearLoading from './LinearLoading';

class Webview extends Component {
    static propTypes = {
        isContentShown: PropTypes.bool.isRequired,
        uri: PropTypes.string.isRequired,
        brandColor: PropTypes.string.isRequired,
        title: PropTypes.string,
        size: PropTypes.string.isRequired,
        hideWebview: PropTypes.func.isRequired,
        updateWebviewTitle: PropTypes.func.isRequired,
        resetWebview: PropTypes.func.isRequired,
        showWebviewContent: PropTypes.func.isRequired,
        hideWebviewContent: PropTypes.func.isRequired,
    };

    state = {
        shouldShowLinearLoader: true,
    };

    componentDidMount() {
        setTimeout(() => this.props.showWebviewContent(), ANIMATION_TIMINGS.WEBVIEW_CONTENT_TRANSITION);
        window.addEventListener('message', this.onMessage);
    }

    onMessage = (event) => {
        if (this.props.uri.startsWith(event.origin)) {
            const action = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
            const result = {
                hasSucceeded: true,
                id: action.id,
            };

            try {
                this.handleMessageAction(action);
            } catch (e) {
                result.hasSucceeded = false;
                result.args = e.message;
            }

            this._iframe.contentWindow.postMessage(result, '*');
        }
    };

    handleMessageAction(action) {
        switch (action.type) {
            case 'CLOSE_WEBVIEW':
                this.onClose();
                break;
            case 'SET_TITLE':
                this.props.updateWebviewTitle(action.title);
                break;
            default:
                throw new Error('Unhandled action');
        }
    }

    componentWillUnmount() {
        this.props.resetWebview();
        window.removeEventListener('message', this.onMessage);
    }

    onClose = () => {
        this.props.hideWebviewContent();
        setTimeout(() => this.props.hideWebview(), ANIMATION_TIMINGS.WEBVIEW_CONTENT_TRANSITION);
    };

    onWebviewClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    hideLinearLoader = () => {
        this.setState({ shouldShowLinearLoader: false });
    };

    render() {
        const { uri, size, title, isContentShown, brandColor } = this.props;
        const { shouldShowLinearLoader } = this.state;

        const content = isContentShown && (
            <CSSTransition classNames="webview-content" timeout={ANIMATION_TIMINGS.WEBVIEW_CONTENT_TRANSITION}>
                <div className={['webview-container', size].join(' ')} key="content">
                    <div id="webview-header">
                        <div className="header-content">{title}</div>
                        <div className="close-handle" onClick={this.onClose}>
                            <i className="fa fa-times"></i>
                        </div>
                    </div>
                    <div id="webview-iframe-container" className={isMobile().apple.device ? 'ios' : ''}>
                        {shouldShowLinearLoader && <LinearLoading color={brandColor} />}
                        <iframe
                            ref={(c) => (this._iframe = c)}
                            onLoad={this.hideLinearLoader}
                            id="webview-iframe"
                            name="web_messenger_ref"
                            src={uri}
                            sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-popups-to-escape-sandbox"
                        ></iframe>
                    </div>
                </div>
            </CSSTransition>
        );

        return (
            <TransitionGroup id="webview" onClick={this.onWebviewClick}>
                {content}
            </TransitionGroup>
        );
    }
}

const mapStateToProps = ({ webview, config: { colors } }) => {
    return {
        ...webview,
        brandColor: colors.brandColor,
    };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            hideWebview,
            updateWebviewTitle,
            resetWebview,
            showWebviewContent,
            hideWebviewContent,
        },
        dispatch,
    );

export default connect(mapStateToProps, mapDispatchToProps, null, {
    forwardRef: true,
})(Webview);
